import { Splide, SplideSlide } from "@splidejs/react-splide";

import "@splidejs/react-splide/css";

import wb from "./img/wb.webp";
import ofd from "./img/ofd.webp";
import magnit from "./img/magnit.webp";
import dm from "./img/dm.webp";
import kuper from "./img/kuper.webp";

import "./style.scss";

const Partners = () => {
    return (
        <div className="partners">
            <span className="partners__title">Наши основные партнёры:</span>
            <div className="partners__container">
                <div className="partners__slider">
                    <Splide
                        options={{
                            perPage: 5,
                            pagination: false,
                            gap: 30,
                            arrows: false,
                            breakpoints: {
                                600: {
                                    perPage: 3,
                                    height: 68,
                                    type: "loop",
                                },
                            },
                        }}
                    >
                        {partnersArr.map((i, idx) => (
                            <SplideSlide key={idx}>
                                <img src={i} className="partners_img" />
                            </SplideSlide>
                        ))}
                    </Splide>
                </div>
            </div>
        </div>
    );
};

export default Partners;

const partnersArr = [wb, ofd, magnit, dm, kuper];
